import { render } from "./PlanContainerJournal.vue?vue&type=template&id=e88a86fa&ts=true"
import script from "./PlanContainerJournal.vue?vue&type=script&lang=ts"
export * from "./PlanContainerJournal.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\BuildAgent\\work\\170657b851b0ad53\\Loading\\Loading\\loading_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__